import { MutationTree } from 'vuex';
import { EFieldMutation } from './field.constants';
import { IFieldState } from './field.types';
import { IField } from '@/document-edit/assembler/fields/types/field';

export const mutations: MutationTree<IFieldState> = {
  [EFieldMutation.SetLoading](state: IFieldState, loading: boolean) {
    state.loading = loading;
  },
  [EFieldMutation.SetFields](state: IFieldState, fields: IField[]) {
    state.fields = fields;
  },
  [EFieldMutation.SetPageWidth](state: IFieldState, pageWidth: number) {
    state.pageWidth = pageWidth;
  },
  [EFieldMutation.UpdateField](state: IFieldState, field) {
    state.fields = state.fields.map((stateField: IField) =>
      stateField.id === field.id ? field : stateField
    );
  },
  [EFieldMutation.SetVerifiedInitialFieldIds](
    state: IFieldState,
    verifiedInitialFieldIds: string[]
  ) {
    state.verifiedInitialFieldIds = verifiedInitialFieldIds;
  },
};
